/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ClientCaseDefinition {
  Appointment = 'Appointment',
  MessagingConversation = 'MessagingConversation',
  PhysicalAppointment = 'PhysicalAppointment'
}
